import { Close } from '@mui/icons-material'
import {
  Alert,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Pagination,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  TextField,
  Button
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import {
  useDownloadReports,
  useFetchBillwiseReport
} from '../../../modules/reports/reportsHooks'
import MainCard, {
  ErrorScreen,
  LoadingDialog,
  SnackBarHideDuration,
  SnackBarTransition,
  StyledTableCell,
  StyledTableRow
} from '../../../utils/ui_utils'
import ListTypeShimmer from '../../../utils/ui_components/shimmers/listTypeShimmer'
import moment from 'moment'
import { downloadReportsSlice } from '../../../modules/reports/reportsSlice'
import { useDispatch } from 'react-redux'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import { ReportsApipath, generateXLSXCSV } from '../../../utils/tsUtils/utils'

const UserwiseReportDetails = ({
  visibility,
  onClose,
  user,
  selectedOutlet,
  fromDate,
  toDate
}) => {
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(15)
  const [pagecount, setPageCount] = useState(1)
  const [goToPageInput, setGoToPageInput] = useState('')
  const {
    billwiseReportData,
    billwiseReportError,
    billwiseReportFetch,
    billwiseReportLoading
  } = useFetchBillwiseReport()

  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const fetchRecord = (page) => {
    let payload = {
      from_date: fromDate,
      to_date: toDate,
      outlet_id: selectedOutlet,
      user_id: user.UserId,
      pageNumber: page,
      limit: limit
    }

    billwiseReportFetch(payload)
  }
  const dispatch = useDispatch()

  const { downloadReportsLoading, downloadReportsFetch } = useDownloadReports()
  useEffect(() => {
    dispatch(downloadReportsSlice.actions.reset())
  }, [])

  const fetchBillWiseReportOnError = () => {
    fetchRecord(page)
  }

  const handlePageChange = async (event, value) => {
    setPage(value)
    fetchRecord(value)
  }

  const handleGoToPageChange = (event) => {
    const value = event.target.value
    if (value === '' || /^\d+$/.test(value)) {
      setGoToPageInput(value)
    }
  }

  const handleGoToPageSubmit = () => {
    const pageNumber = parseInt(goToPageInput, 10)
    if (pageNumber >= 1 && pageNumber <= pagecount) {
      handlePageChange(null, pageNumber)
      setGoToPageInput('')
    }
  }

  const handleGoToPageKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleGoToPageSubmit()
    }
  }

  const pageCount = (data1) => {
    let count = Math.ceil(data1 / limit)
    setPageCount(count)
  }

  useEffect(() => {
    if (billwiseReportData.data?.length > 0) {
      pageCount(billwiseReportData.total)
    }
  }, [billwiseReportData])

  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const exportToCsv = async () => {
    try {
      let payload = {
        from_date: moment(fromDate).format('YYYY-MM-DD'),
        to_date: moment(toDate).add(1, 'days').format('YYYY-MM-DD'),
        outlet_id: selectedOutlet,
        pageNumber: 1,
        limit: 100,
        total: billwiseReportData?.total || 15,
        user_id: user.UserId,
        url: ReportsApipath.BILLWISE,
        type: 'userwisebill'
      }

      const reports = await downloadReportsFetch(payload)

      let data1 = [...reports.payload]

      data1.unshift(
        {
          Bill_Date: `Billwise report -${user.UserName}`
        },
        {}
      )

      const options = {
        keys: [
          { field: 'Bill_Date', title: 'Date' },
          { field: 'Bill_Num', title: 'Bill Number' },
          { field: 'Terminal', title: 'Terminal' },
          { field: 'Total_Qty', title: 'Quantity' },
          { field: 'Total_GST', title: 'GST' },
          { field: 'Total_Cess', title: 'Cess' },
          { field: 'Total_Disc', title: 'Discount' },
          { field: 'PaymentMode', title: 'Payment Mode' },
          { field: 'Total', title: 'Total' }
        ]
      }
      let filename = `billUserWiseReport_${user.UserName}`
      filename += `_${payload.from_date}_to_${payload.to_date}`

      // const csv = await generateCSV(data1, options3, filename)
      const csv = await generateXLSXCSV(data1, options.keys, filename)

      toastMessage('CSV Downloaded Sucessfully')
    } catch (error) {
      console.error('Error while converting JSON to CSV', error)
      toastMessage('Error While Downloading csv', 'error')
    }
  }
  return (
    <>
      <Dialog
        maxWidth="xl"
        open={visibility}
        onClose={() => {
          setPage(1)
          onClose()
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography variant="h6">
            Billwise Report - {user.UserName}
            {billwiseReportData.data && billwiseReportData.data.length > 0 && (
              <Tooltip title="Export to CSV" placement="top" arrow>
                <IconButton
                  variant="contained"
                  onClick={exportToCsv}
                  disabled={downloadReportsLoading}
                  size="large"
                >
                  {downloadReportsLoading && <CircularProgress size={20} />}
                  {!downloadReportsLoading ? (
                    <>
                      {' '}
                      <CloudUploadIcon fontSize="large" />
                    </>
                  ) : (
                    <> </>
                  )}
                </IconButton>
              </Tooltip>
            )}
          </Typography>

          <IconButton
            onClick={() => {
              setPage(1)
              onClose()
            }}
            sx={{
              '&:hover': {
                color: 'red'
              }
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <Grid container spacing={2} sx={{ p: 2 }}>
          <Grid item xs={12} md={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} md>
            {billwiseReportLoading && !billwiseReportError ? (
              <Grid container spacing={12}>
                <Grid item xs sm md>
                  <MainCard content={false} sx={{ mt: 1.5 }}>
                    <Box sx={{ pt: 1, pr: 2, pl: 2, pb: 1 }}>
                      <ListTypeShimmer />
                    </Box>
                  </MainCard>
                </Grid>
              </Grid>
            ) : !billwiseReportLoading && billwiseReportError ? (
              <Grid container spacing={12}>
                <Grid item xs sm md>
                  <ErrorScreen
                    onClick={() => {
                      fetchBillWiseReportOnError()
                    }}
                  />
                </Grid>
              </Grid>
            ) : (
              !billwiseReportLoading &&
              !billwiseReportError &&
              billwiseReportData && (
                <Grid container spacing={12}>
                  <Grid item xs sm md>
                    <MainCard content={false}>
                      <CardContent sx={{ flexGrow: 1 }}>
                        <TableContainer component={Card}>
                          <Table size="small">
                            <TableHead size="small">
                              <StyledTableRow>
                                <StyledTableCell>Date</StyledTableCell>
                                <StyledTableCell align="left">
                                  {' '}
                                  Bill #
                                </StyledTableCell>
                                <StyledTableCell align="right">
                                  {' '}
                                  Terminal
                                </StyledTableCell>
                                <StyledTableCell align="right">
                                  {' '}
                                  Qty
                                </StyledTableCell>
                                <StyledTableCell align="right">
                                  {' '}
                                  GST
                                </StyledTableCell>
                                <StyledTableCell align="right">
                                  {' '}
                                  CESS
                                </StyledTableCell>
                                <StyledTableCell align="right">
                                  {' '}
                                  Discount
                                </StyledTableCell>
                                <StyledTableCell align="right">
                                  {' '}
                                  Payment Mode
                                </StyledTableCell>
                                <StyledTableCell align="right">
                                  {' '}
                                  Total
                                </StyledTableCell>
                              </StyledTableRow>
                            </TableHead>
                            <TableBody>
                              {billwiseReportData.data?.map((row, i) => (
                                <StyledTableRow key={i} hover>
                                  <StyledTableCell>
                                    {moment(row.Bill_Date).format('DD-MM-YYYY')}
                                  </StyledTableCell>
                                  <StyledTableCell align="left">
                                    {row?.Bill_Num}
                                  </StyledTableCell>
                                  <StyledTableCell align="right">
                                    {row?.Terminal}
                                  </StyledTableCell>
                                  <StyledTableCell align="right">
                                    {row?.Total_Qty.toFixed(3)}
                                  </StyledTableCell>
                                  <StyledTableCell align="right">
                                    {row?.Total_GST.toFixed(2)}
                                  </StyledTableCell>
                                  <StyledTableCell align="right">
                                    {row?.Total_Cess.toFixed(2)}
                                  </StyledTableCell>
                                  <StyledTableCell align="right">
                                    {row?.Total_Disc.toFixed(2)}
                                  </StyledTableCell>
                                  <StyledTableCell align="right">
                                    {row?.PaymentMode}
                                  </StyledTableCell>
                                  <StyledTableCell align="right">
                                    {row?.Total.toFixed(2)}
                                  </StyledTableCell>
                                </StyledTableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </CardContent>
                      {pagecount > 1 && (
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            p: 2,
                            backgroundColor: 'grey.50',
                            borderTop: '1px solid',
                            borderColor: 'divider'
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              width: '100%'
                            }}
                          >
                            <Pagination
                              count={pagecount}
                              page={page}
                              color="secondary"
                              size="small"
                              boundaryCount={2}
                              siblingCount={0}
                              showFirstButton
                              showLastButton
                              onChange={handlePageChange}
                              sx={{
                                '& .MuiPaginationItem-root': {
                                  transition: 'all 0.2s ease-in-out'
                                }
                              }}
                            />
                          </Box>
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              gap: 1.5,
                              backgroundColor: 'white',
                              p: 2,
                              borderRadius: 1,
                              boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                              transition: 'box-shadow 0.2s ease-in-out',
                              '&:hover': {
                                boxShadow: '0 2px 6px rgba(0,0,0,0.12)'
                              }
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                color: 'text.secondary',
                                fontWeight: 500
                              }}
                            >
                              Jump to
                            </Typography>
                            <TextField
                              size="small"
                              value={goToPageInput}
                              onChange={handleGoToPageChange}
                              onKeyPress={handleGoToPageKeyPress}
                              placeholder="Page"
                              sx={{
                                width: '80px',
                                '& .MuiOutlinedInput-root': {
                                  backgroundColor: 'white',
                                  transition: 'all 0.2s ease-in-out',
                                  '& fieldset': {
                                    borderColor: 'grey.300',
                                    borderWidth: '1px'
                                  },
                                  '&:hover fieldset': {
                                    borderColor: 'secondary.main',
                                    borderWidth: '1.5px'
                                  },
                                  '&.Mui-focused fieldset': {
                                    borderColor: 'secondary.main',
                                    borderWidth: '2px',
                                    boxShadow:
                                      '0 0 0 3px rgba(156, 39, 176, 0.1)'
                                  }
                                },
                                '& .MuiOutlinedInput-input': {
                                  textAlign: 'center',
                                  fontWeight: 500,
                                  padding: '7px 8px',
                                  height: '20px',
                                  lineHeight: '20px'
                                }
                              }}
                            />
                            <Typography
                              variant="body2"
                              sx={{
                                color: 'text.secondary',
                                fontWeight: 400
                              }}
                            >
                              of {pagecount}
                            </Typography>
                            <Button
                              variant="contained"
                              color="secondary"
                              size="small"
                              onClick={handleGoToPageSubmit}
                              disabled={
                                !goToPageInput ||
                                parseInt(goToPageInput, 10) < 1 ||
                                parseInt(goToPageInput, 10) > pagecount
                              }
                              sx={{
                                textTransform: 'none',
                                fontWeight: 500,
                                px: 2,
                                py: 0.75,
                                height: '34px',
                                lineHeight: 1,
                                transition: 'all 0.2s ease-in-out',
                                '&:hover': {
                                  transform: 'translateY(-1px)',
                                  boxShadow: '0 4px 8px rgba(156, 39, 176, 0.3)'
                                },
                                '&:active': {
                                  transform: 'translateY(0)'
                                }
                              }}
                            >
                              Go
                            </Button>
                          </Box>
                        </Box>
                      )}
                    </MainCard>
                  </Grid>
                </Grid>
              )
            )}
          </Grid>
        </Grid>
      </Dialog>

      <div>
        <Snackbar
          open={snackbar}
          autoHideDuration={SnackBarHideDuration}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleSnackbarClose}
          TransitionComponent={SnackBarTransition}
        >
          <Alert onClose={handleSnackbarClose} severity={severity}>
            {PopUpMessage}
          </Alert>
        </Snackbar>
      </div>

      <LoadingDialog open={downloadReportsLoading} />
    </>
  )
}

export default UserwiseReportDetails
